const generateImgURL = async (image) => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Client-ID b460a924d59e16c");

    var formdata = new FormData();
    formdata.append("image", image);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    return await fetch("https://api.imgur.com/3/image", requestOptions)
        .then(response => response.json())
        .then(result => result.data.link)
        .catch(error => console.log('error', error));
}

$('#dog-photo').on('change', async function () {
    var $files = $(this).get(0).files;
    console.log($files);

    $('.dog-details__icon-loader').removeClass('hidden');

    if ($files.length) {
        // Reject big files
        if ($files[0].size > $(this).data('max-size') * 1024) {
            console.log('Please select a smaller file');
            return false;
        }

        const url = await generateImgURL($files[0])
        console.log(url);

        $('#dog-photo-img').attr('src', url)
        $('#dog-details  .dog-details__icon > svg').addClass('hidden')
        $('#dog-photo-img').removeClass('hidden')

        const editDogForm = $('#dog-details')
        const payload = {
            id: editDogForm.attr('data-dog-id'),
            email: editDogForm.attr('data-customer-email') || "",
            name: $('#dog-name').val() || "",
            breed: $('#breed').val() || "",
            birth: $('#dog-birth').val() || "",
            weight: $('#weight').val() || "",
            favorite_park: $('#favorite-park').val() || "",
            favorite_toy: $('#favorite-toy').val() || "",
            interest: $('#interest').val() || "",
            loves: $('#loves').val() || "",
            energy_level: $('#energy-level').val() || "",
            favorite_position: $('#favorite-position').val() || "",
            loves_eating: $('#loves-eating').val() || "",
            facebook: $('#dog-facebook').val() || "",
            instagram: $('#dog-instagram').val() || "",
            photo: url,
        }

        const result = await fetch(`${DOGS_URI}/${encodeURIComponent(payload.id)}?${dogsQuery()}`, { method: 'PUT', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });

      $('.dog-details__icon-loader').addClass('hidden');

        const feedbackMessage = $('.dog-details__feedback-message');

        result.json().then((response) => {
            feedbackMessage.html(accountSuccessFeedback);
            feedbackMessage.addClass('show');

            setTimeout(function () {
                feedbackMessage.removeClass('show');
                feedbackMessage.removeClass('error');
            }, 5000);

            $(`.dogs__wrapper[data-dog-id="${editDogForm.attr('data-dog-id')}"] img`).attr('src', url)

        }).catch(() => {
            feedbackMessage.html(accountErrorFeedback);
            feedbackMessage.addClass('show error');

            setTimeout(function () {
                feedbackMessage.removeClass('show');
                feedbackMessage.removeClass('error');
            }, 5000);
        })


    }
  
    $('.dog-details__icon-loader').addClass('hidden');
});